<template>
    <div class="box-empty-home ">
        <div class="title-empty-home pb0" v-html="$t('empty_home_5')"></div>
    </div>
</template>

<script>
import memberMixins from "@/mixins/memberMixins";
import {mapState} from "vuex";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "EventEmptyHomeLayout",
    mixins: [memberMixins, alertMixins],
    components: {},
    props: {
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {
    },
    methods: {
        updateAlert() {
        },},
    watch: {},
}
</script>
